module.exports = __webpack_public_path__ + "img/ep-C-dosis.f312351c.jpg";